import React, { useState } from 'react';
import { SubmitHandler, FieldValues } from 'react-hook-form';
import { InputMedication } from './components/inputMedication';
import { InputMedicalProblem } from './components/inputMedicalProblem';
import { InputGeneralInformation } from './components/inputGeneralInformation';
import useFormAiUnderwriterScore from './hooks/useFormAiUnderwriterScore';
import { sendAiModelResult } from './infrastructure/autocompleteResultsRepository';
import ModelResult from './components/modelResult';
import styles from './IGPRScore.module.scss';
import { setGeneratingExtraction, useAppDispatch } from 'app/redux';
import { Button } from '@zurich-primitives/button';
import { ReactComponent as HistoryIcon } from 'app/assets/Icons/History.svg';

export const FormIGPRScore: React.FC = () => {
  const {
    openModal,
    setOpenModal,
    control,
    register,
    handleSubmit,
    isValid,
    errors,
    aiModelResponse,
    setAiModelResponse,
    reset
  } = useFormAiUnderwriterScore();
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);

  const [resultsAvailable, setResultsAvailable] = useState(false);

  const onSubmit: SubmitHandler<FieldValues> = async (data: any) => {
    setLoading(true);
    dispatch(setGeneratingExtraction(true));
    sendAiModelResult(data)
      .then((data) => {
        setAiModelResponse(data);
        setResultsAvailable(true);
      })
      .finally(() => {
        setLoading(false);
        dispatch(setGeneratingExtraction(false));
        setOpenModal(true);
      });
    setTimeout(() => {
      window.scrollTo({
        top: 9999,
        behavior: 'smooth'
      });
    }, 250);
  };

  const handleReset = () => {
    reset();
    setAiModelResponse({
      prediction: undefined,
      recommendation: '',
      reasoning: {}
    });
    setOpenModal(false);
    setResultsAvailable(false);
  };

  return (
    <>
      <form className="ml-8 mr-8" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className={styles.root}>
          <InputMedicalProblem control={control} />
          <InputMedication control={control} />
          <InputGeneralInformation register={register} errors={errors} />
        </div>
        <div className={styles.root}>
          <div></div>
          <div></div>

          <div className={styles.formReadingsRoot}>
            <Button
              onClick={handleReset}
              variant="secondary"
              className={styles['reset-analysis']}
              aria-label="Reset Analysis"
              disabled={!resultsAvailable}
            >
              <Button.Label>Reset Analysis</Button.Label>
              <Button.Icon>
                <HistoryIcon />
              </Button.Icon>
            </Button>

            <Button
              onClick={handleSubmit(onSubmit)}
              variant="secondary"
              className={styles['execute-button']}
              aria-label="Execute AI Model"
              disabled={!isValid}
            >
              {loading ? (
                <div className={styles.spinner}></div>
              ) : (
                <Button.Label>Execute</Button.Label>
              )}
            </Button>
          </div>
        </div>
      </form>
      <ModelResult hidden={!openModal} modelResult={aiModelResponse} />
    </>
  );
};

export default FormIGPRScore;
